module.exports = "<div ng-if=$ctrl.showList class=item> <product-grid-view on-compare-click=$ctrl.addtocompare(product) product=$ctrl.product></product-grid-view> </div> <div ng-if=!$ctrl.showList class=item> <product-list-view on-compare-click=$ctrl.addtocompare(product) product=$ctrl.product></product-list-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/product/product.template.html
// module id = 108
// module chunks = 0